// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.healthgoal.PatientHealthGoalResponse */
/* istanbul ignore next */
@GandalfModel
export class PatientHealthGoalResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	careExperience!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	dateReported!: Date | null;

	@GandalfProperty({ designType: String })
	goal!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	inactiveDate!: Date | null;

	@GandalfProperty({ designType: Number })
	patientHealthGoalId!: number | null;

	@GandalfConstantDecorator(constants.PatientHealthGoalStatus)
	@GandalfProperty({ designType: constants.PatientHealthGoalStatus })
	status!: constants.PatientHealthGoalStatus | null;

	@GandalfProperty({ designType: String })
	treatmentIntervention!: string | null;

	@GandalfProperty({ designType: String })
	value!: string | null;

}
